import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { models } from 'reducers/models/selectors';
import { seriesModels, series } from 'reducers/series/selectors';
import { theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  series,
  models,
  seriesModels,
  theme,
});

export const isSelectedSeries = ({ selectedSeriesId, seriesId }) =>
  selectedSeriesId === seriesId;

export const modelUrl = ({ seriesId, seriesModels }) => {
  let availableModel =
    (seriesModels && seriesModels.find(model => model.remainingQuota > 0)) ||
    seriesModels[0];
  let modelUrl = availableModel
    ? `/series/${seriesId}/models/${availableModel.id}`
    : '#';
  return modelUrl;
};

export const hasQuota = ({ seriesModels }) => {
  let total = 0;
  seriesModels.forEach(sm => {
    let quota = parseInt(sm.quota, 10);
    total += quota;
  });
  return total > 0;
};

export const nameStyle = ({ theme }) => ({
  fontFamily: theme.font,
  textTransform: 'uppercase',
});

export default compose(
  connect(mapStateToProps),
  addProps({ isSelectedSeries, modelUrl, hasQuota, nameStyle }),
);
